import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserVerifyComponent } from './components/user-verify/user-verify.component';

const routes: Routes = [
  {
    path: 'verify/:token',
    component: UserVerifyComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
